import { lazy } from "react";

export const SettingsHubPageAsync = lazy(async function () {
  return import("./SettingsHubPage").then((module) => ({ default: module.SettingsHubPage }));
});
